import { initializeApp } from "firebase/app";
import { getAuth,signInWithCustomToken  } from "firebase/auth";
import { getRemoteConfig } from "firebase/remote-config";
import { getStorage } from "firebase/storage";
import { getFirestore } from 'firebase/firestore';
import { getMessaging } from "firebase/messaging";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Remote Config - wrap in try/catch for environments where IndexedDB is unavailable
let remoteConfig = null;
try {
  remoteConfig = getRemoteConfig(app);
} catch (e) {
  console.warn('Firebase Remote Config initialization failed:', e.message);
}

const storage = getStorage(app);

// Initialize Firestore and get a reference to the service
const db = getFirestore(app);

// Messaging service - wrap in try/catch for unsupported browsers
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (e) {
  console.warn('Firebase Messaging initialization failed:', e.message);
}

// login after redirect if user 
async function signInWithToken(token) {
  // Use the token to sign in
  signInWithCustomToken(auth,token)
    .then(() => {
      window.history.replaceState(null, '', (() => {
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        return url.pathname + url.search + url.hash;
      })());
    })
    .catch((error) => {
      console.error("Sign-in failed:", error);
    });
}

const queryParams = new URLSearchParams(window.location.search);
const token = queryParams.get("token");
if (token) {
  signInWithToken(token)
} else {
  console.log("No token in URL");
}
// end login after redirect

export {auth,remoteConfig,storage,db,messaging};
